import styled from 'styled-components';
import { userPanelElementStyles } from '../../../styles/sharedStyles';

export const StyledEmployeesAllElement = styled.div`
    ${userPanelElementStyles};
`;
